// @ts-strict-ignore
import React, { useCallback, useMemo } from "react"
import { Checkbox } from "@node-space/ui-components"
import { BeneficiaryEntityType } from "types/beneficiaries"
import { ContactFiatInstrumentFormData } from "pages/Contacts/schemas/contactFiatInstrumentSchema"
import { UseFormSetValue } from "react-hook-form"
import { Contact, ContactEntityCompany, ContactEntityIndividual } from "types/contacts"
import { useTranslation } from "react-i18next"

interface AccountHolderDetailsCopyProps {
  formValues: ContactFiatInstrumentFormData
  contact: Contact
  setValue: UseFormSetValue<ContactFiatInstrumentFormData>
}
    
export const AccountHolderDetailsCopy = ({ formValues, contact, setValue }: AccountHolderDetailsCopyProps) => {
  const { t } = useTranslation()
  
  const isIndividual = useMemo(() => {
    return contact?.entity?.type === BeneficiaryEntityType.INDIVIDUAL
  }, [contact?.entity?.type])

  const accountHolderName = useMemo(() => {
    if (isIndividual) {
      const individual = contact?.entity as ContactEntityIndividual
      return `${individual?.firstName} ${individual?.lastName}`
    }

    return (contact?.entity as ContactEntityCompany)?.legalName
  }, [contact, isIndividual])

  const checkboxLabel = useMemo(() => {
    return isIndividual ? t('contacts.useSameIndividualNamesAsContact') : t('contacts.useSameBusinessNameAsContact')
  }, [t, isIndividual])

  const handleSameAccountHolderNameAsContactChange = useCallback((isSame: boolean) => {
    setValue('sameAccountHolderNameAsContact', isSame)    

    if (isIndividual) {
      const individual = contact?.entity as ContactEntityIndividual
      setValue('firstName', isSame ? individual?.firstName : '')
      setValue('lastName', isSame ? individual?.lastName : '')
      return
    }

    const company = contact?.entity as ContactEntityCompany
    setValue('businessName', isSame ? company?.legalName : '')

  }, [formValues, contact, setValue, isIndividual])

  return (
    <Checkbox
      id="account-holder-name-copy-details-checkbox"
      name="account-holder-name-copy-details-checkbox"
      testId="account-holder-name-copy-details-checkbox"
      onCheckedChange={handleSameAccountHolderNameAsContactChange}
      label={checkboxLabel}
      checked={formValues?.sameAccountHolderNameAsContact}
    >
      {accountHolderName}
    </Checkbox>
  )
}